
import React from 'react';

export const SunIcon: React.FC<{ className?: string }> = ({ className }) => (
  <span className={`material-symbols-outlined ${className}`}>
    light_mode
  </span>
);